import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized } from '@lit/localize';
import { classMap } from 'lit/directives/class-map.js';
import { provide } from '@lit/context';
import { accordionInvertedContext } from './accordion-context.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { accordionStyles } from './accordion.styles.js';
let HlxAccordion = class HlxAccordion extends HelixElement {
    constructor() {
        super(...arguments);
        this.inverted = false;
    }
    render() {
        return html `
            <div
                class="${classMap({
            'hlx-accordion': true,
            'hlx-accordion-inverted': this.inverted,
        })};">
                <div class="hlx-accordion-top-line"></div>
                <slot></slot>
            </div>
        `;
    }
};
HlxAccordion.styles = [componentStyles, accordionStyles];
__decorate([
    provide({ context: accordionInvertedContext }),
    property({ type: Boolean, reflect: true })
], HlxAccordion.prototype, "inverted", void 0);
HlxAccordion = __decorate([
    customElement('hlx-accordion'),
    localized()
], HlxAccordion);
export { HlxAccordion };
//# sourceMappingURL=accordion.js.map